export const DEPOSIT_SURVEY_ANSWERS = [
    'confusing_top_up_process',
    'just_browsing_app',
    'not_ready_yet',
    'technical_problems_with_funding',
];

export const DEPOSIT_SURVEY_ANSWER_OTHERS = 'other_reasons';
